(() => {
  if (window.pbListenPlayerLoaderReady) return;
  window.pbListenPlayerLoaderReady = true;

  const preloadMargin = 1800;
  const loadAllDelay = 900;
  const playerSelector = '[data-apple-music-player], [data-pb-listen-player]';
  const spotifyStyleId = 'pb-listen-spotify-runtime-style';

  const ensureSpotifyStyle = () => {
    if (document.getElementById(spotifyStyleId)) return;

    const style = document.createElement('style');
    style.id = spotifyStyleId;
    style.textContent = `
      .pb-listen-product__frame-wrap--spotify {
        display: flex !important;
        align-items: stretch !important;
        min-height: var(--pb-listen-player-height, 450px) !important;
        height: var(--pb-listen-player-height, 450px) !important;
      }

      .pb-listen-product__iframe--spotify {
        display: block !important;
        width: 100% !important;
        height: var(--pb-listen-player-height, 450px) !important;
        min-height: var(--pb-listen-player-height, 450px) !important;
        border: 0 !important;
      }
    `;
    document.head.append(style);
  };

  const loadPlayer = (root) => {
    if (!root || root.dataset.pbListenLoaded === 'true' || root.dataset.appleMusicLoaded === 'true') return;

    const iframe = root.querySelector('iframe[data-src]');
    if (!iframe || !iframe.dataset.src) return;

    root.dataset.pbListenLoaded = 'true';
    root.dataset.appleMusicLoaded = 'true';
    iframe.setAttribute('loading', 'eager');
    iframe.src = iframe.dataset.src;
  };

  const isPlayerActive = (root) => {
    const panel = root.closest('[data-pb-listen-panel]');
    return !panel || !panel.hidden;
  };

  const shouldLoadEarly = (root) => {
    const rect = root.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    return rect.top < viewportHeight + preloadMargin && rect.bottom > -preloadMargin;
  };

  const initTabs = () => {
    document.querySelectorAll('[data-pb-listen-root]').forEach((root) => {
      if (root.dataset.pbListenTabsReady === 'true') return;
      root.dataset.pbListenTabsReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-pb-listen-tab]'));
      if (!tabs.length) return;

      const getPanel = (id) => {
        const panel = document.getElementById(id);
        return panel && root.contains(panel) ? panel : null;
      };

      const activateTab = (tab) => {
        const panelId = tab.getAttribute('aria-controls');
        if (!panelId) return;

        tabs.forEach((item) => {
          const itemPanelId = item.getAttribute('aria-controls');
          const itemPanel = itemPanelId ? getPanel(itemPanelId) : null;
          const isSelected = item === tab;

          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          if (itemPanel) itemPanel.hidden = !isSelected;
        });

        const activePanel = getPanel(panelId);
        if (activePanel) loadPlayer(activePanel);
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activateTab(tab));
      });
    });
  };

  const initPlayers = () => {
    ensureSpotifyStyle();
    initTabs();

    const players = Array.from(document.querySelectorAll(playerSelector));

    if (!players.length) return;

    players.forEach((player) => {
      if (isPlayerActive(player) && shouldLoadEarly(player)) loadPlayer(player);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (!isPlayerActive(entry.target)) return;

          loadPlayer(entry.target);
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: `${preloadMargin}px 0px`,
        threshold: 0.01
      });

      players.forEach((player) => {
        if (player.dataset.pbListenLoaded !== 'true' && player.dataset.appleMusicLoaded !== 'true') {
          observer.observe(player);
        }
      });
    }

    window.setTimeout(() => {
      players.filter(isPlayerActive).forEach(loadPlayer);
    }, loadAllDelay);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlayers, { once: true });
  } else {
    initPlayers();
  }

  window.addEventListener('pageshow', initPlayers);
  document.addEventListener('shopify:section:load', initPlayers);
})();